<template>
  <svg
    version="1.1"
    class="down_arrow"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 35 35"
    width="8px"
    height="8px"
    style="enable-background: new 0 0 35 35"
    xml:space="preserve"
  >
    <path
      fill="currentColor"
      d="M26.3,4.1H8.7v13.4H2.2l15.3,14.8,15.3-14.8h-6.4V4.1Z"
    />
  </svg>
</template>
